export { default as PostRenderer } from './component';
